import AssetLocations from './AssetLocations'

export default AssetLocations
